
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import './GroupPicker.scss'
import { Passenger } from '../models/Passenger';
import Group from '../models/Group';

@Component({
    template: require("./GroupPicker.vue.html"),
    components: {
        
    }
})
export class GroupPicker extends Vue {

    public static NEW_GROUP_CREATOR_ITEM: string = "- New tag -";

    @Prop({default: () => []})  
    groups: Group[];

    @Prop({default: () => []})  
    selectedGroups: Group[];

    @Prop({default: ""})  
    label: string;

    @Prop({default: false})  
    enableCreation: boolean;

    @Prop({default: true})  
    prependIcon: boolean;

    editedSelectedGroups: Group[] = [];
    searchInput: string = "";

    editedSelectableGroups: Group[] = [];
    newGroups: Group[] = [];

    editableSelectedGroups: Group[] = [];

    get newUniqueGroups(): Group[] {
        return Group.getUniqueGroups(this.newGroups);
    } 

    @Watch('selectedGroups', {immediate: true})
    onSelectedGroupsChanged(val: Group[], oldVal: Group[]) { 
        // console.log("onSelectedGroupsChanged", val)
        // SelectedGroups prop changed, we should reset local vars
        this.editableSelectedGroups = [...val];
        this.editedSelectedGroups = [];
        this.searchInput = "";
    }

    get selectableGroups(): Group[]{
        const groups = this.groups.filter(g => g.name);
        if (this.enableCreation 
                && this.searchInput 
                && !groups.find(g => g.name.toLowerCase() === this.searchInput.toLowerCase())){
            groups.push({ name: GroupPicker.NEW_GROUP_CREATOR_ITEM, creator: true});
        }
        return Group.getUniqueGroups(groups);
    }

    @Watch('selectableGroups', {immediate: true})
    onSelectableGroupsChanged(val: Group[], oldVal: Group[]) { 
        // console.log("onSelectableGroupsChanged", val);
        this.editedSelectableGroups =  Group.getUniqueGroups(val.concat(...this.newUniqueGroups));
    }

    get selectedGroupNames(): string[]{
        const groupNames = this.editableSelectedGroups.concat(this.editedSelectedGroups).map(g => g.name.trim());
        return Group.getUniqueGroupNames(groupNames).filter(gn => gn);
    }

    set selectedGroupNames(groupNames: string[]){
        // console.log("set selectedGroupNames()", "groupNames:", groupNames);
        const updatedGroupNames: string[] = groupNames.filter(gn => gn !== GroupPicker.NEW_GROUP_CREATOR_ITEM);
        if (groupNames.includes(GroupPicker.NEW_GROUP_CREATOR_ITEM)){
            updatedGroupNames.push(this.searchInput);
        };
        this.editedSelectedGroups = Group.getUniqueGroupNames(updatedGroupNames).map(gn => new Group(gn));
        this.editableSelectedGroups =  this.editedSelectedGroups;
        this.emitChangeEvent();
    }

    filter(item, queryText, itemText) {
        const itemName = item.name.toLowerCase()
        const searchText = queryText.toLowerCase()
        return itemName.indexOf(searchText) > -1 || 
            (item.creator && !this.groups.find(g => g.name.toLowerCase() === this.searchInput.toLowerCase()))
    }

    emitChangeEvent(){
        this.$emit("change", this.editedSelectedGroups);
    }

    onCreateGroup(data: any){
        // console.log("onCreateGroup()");
        const newGroupName = this.searchInput;
        const newGroup = new Group(newGroupName);
        this.newGroups.push(newGroup);
        (this.$refs.inputRef as any).selectItem(newGroupName);
        this.emitChangeEvent();
    }

    onChange(){
        if (this.$refs.inputRef){
            (this.$refs.inputRef as any).blur();
        }
    }

    beforeDestroy(){
        this.editedSelectedGroups = [];
    }
}

export default GroupPicker;
